import {combineReducers, configureStore} from "@reduxjs/toolkit";
import {modalSlice} from "@/store/slices/modalSlice";
import {authApi} from "@/store/api/v1/auth";
import {userApi} from "@/store/api/v1/user";
import {overviewApi} from "@/store/api/v1/overview";
import {companyApi} from "@/store/api/v1/company";
import {dashboardSlice} from "@/store/slices/dashboardSlice";
import {sidebarSlice} from "@/store/slices/sidebarSlice";
import {calendarSlice} from "@/store/slices/calendarSlice";
import {servicesApi} from "@/store/api/v1/services";
import {categoriesApi} from "@/store/api/v1/categories";
import {locationsApi} from "@/store/api/v1/locations";
import {customersApi} from "@/store/api/v1/customers";
import {staffApi} from "@/store/api/v1/staff";
import {impersonateApi} from "@/store/api/v1/impersonate";
import {bookingsApi} from "@/store/api/v1/bookings";
import {integrationsApi} from "@/store/api/v1/integrations";
import {settingsApi} from "@/store/api/v1/settings";
import {userSettingsApi} from "@/store/api/v1/user-settings";
import {paymentsApi} from "@/store/api/v1/payments";
import {updateIndexApi} from "@/store/api/v1/update-index";
import {payoutsApi} from "@/store/api/v1/payouts";
import {paymentSettingsApi} from "@/store/api/v1/payment-settings";
import {galleryApi} from "@/store/api/v1/gallery";
import {widgetSettingsApi} from "@/store/api/v1/widget-settings";
import {couponsApi} from "@/store/api/v1/coupons";
import {discountsApi} from "@/store/api/v1/discounts";
import {statisticsApi} from "@/store/api/v1/statistics";
import {certificationApi} from "@/store/api/v1/certification";
import {storageApi} from "@/store/api/v1/storages";
import {productsApi} from "@/store/api/v1/products";
import {notificationsApi} from "@/store/api/v1/notifications";
import {resourcesApi} from "@/store/api/v1/resources";
import {salaryApi} from "@/store/api/v1/salary";
import {templatesApi} from "@/store/api/v1/templates";
import {messageHelpApi} from "@/store/api/v1/messageHelp";
import {modulesApi} from "@/store/api/v1/modules";
import {creditsApi} from "@/store/api/v1/credits";
import {whatsappTemplateApi} from "@/store/api/v1/whatsapp-templates";
import {eventsApi} from "@/store/api/v1/events";
import {eventTypesApi} from "@/store/api/v1/event-types";
import {speakersApi} from "@/store/api/v1/speakers";
import {eventSessionsApi} from "@/store/api/v1/event-sessions";
import {ratingReviewsApi} from "@/store/api/v1/rating-reviews";
import {adminsApi} from "@/store/api/v1/admins";
import {salesApi} from "@/store/api/v1/sales";
import {giftCardsApi} from "@/store/api/v1/gift-cards";
import {giftCardPurchasesApi} from "@/store/api/v1/gift-card-purchases";
import {tipsApi} from "@/store/api/v1/tips";
import {scheduleApi} from "@/store/api/v1/schedule";
import {rolesApi} from "@/store/api/v1/roles";
import {desksApi} from "@/store/api/v1/desks";

const appReducer = combineReducers({
    [modalSlice.name]: modalSlice.reducer,
    [sidebarSlice.name]: sidebarSlice.reducer,
    [dashboardSlice.name]: dashboardSlice.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [overviewApi.reducerPath]: overviewApi.reducer,
    [companyApi.reducerPath]: companyApi.reducer,
    [calendarSlice.name]: calendarSlice.reducer,
    [servicesApi.reducerPath]: servicesApi.reducer,
    [categoriesApi.reducerPath]: categoriesApi.reducer,
    [locationsApi.reducerPath]: locationsApi.reducer,
    [bookingsApi.reducerPath]: bookingsApi.reducer,
    [eventsApi.reducerPath]: eventsApi.reducer,
    [eventTypesApi.reducerPath]: eventTypesApi.reducer,
    [eventSessionsApi.reducerPath]: eventSessionsApi.reducer,
    [speakersApi.reducerPath]: speakersApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [modulesApi.reducerPath]: modulesApi.reducer,
    [customersApi.reducerPath]: customersApi.reducer,
    [staffApi.reducerPath]: staffApi.reducer,
    [adminsApi.reducerPath]: adminsApi.reducer,
    [ratingReviewsApi.reducerPath]: ratingReviewsApi.reducer,
    [salaryApi.reducerPath]: salaryApi.reducer,
    [integrationsApi.reducerPath]: integrationsApi.reducer,
    [impersonateApi.reducerPath]: impersonateApi.reducer,
    [userSettingsApi.reducerPath]: userSettingsApi.reducer,
    [paymentsApi.reducerPath]: paymentsApi.reducer,
    [payoutsApi.reducerPath]: payoutsApi.reducer,
    [updateIndexApi.reducerPath]: updateIndexApi.reducer,
    [paymentSettingsApi.reducerPath]: paymentSettingsApi.reducer,
    [galleryApi.reducerPath]: galleryApi.reducer,
    [widgetSettingsApi.reducerPath]: widgetSettingsApi.reducer,
    [couponsApi.reducerPath]: couponsApi.reducer,
    [discountsApi.reducerPath]: discountsApi.reducer,
    [giftCardsApi.reducerPath]: giftCardsApi.reducer,
    [giftCardPurchasesApi.reducerPath]: giftCardPurchasesApi.reducer,
    [statisticsApi.reducerPath]: statisticsApi.reducer,
    [certificationApi.reducerPath]: certificationApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [storageApi.reducerPath]: storageApi.reducer,
    [productsApi.reducerPath]: productsApi.reducer,
    [resourcesApi.reducerPath]: resourcesApi.reducer,
    [templatesApi.reducerPath]: templatesApi.reducer,
    [salesApi.reducerPath]: salesApi.reducer,
    [messageHelpApi.reducerPath]: messageHelpApi.reducer,
    [creditsApi.reducerPath]: creditsApi.reducer,
    [whatsappTemplateApi.reducerPath]: whatsappTemplateApi.reducer,
    [tipsApi.reducerPath]: tipsApi.reducer,
    [scheduleApi.reducerPath]: scheduleApi.reducer,
    [rolesApi.reducerPath]: rolesApi.reducer,
    [desksApi.reducerPath]: desksApi.reducer,
});

const rootReducer = (state, action) => {
    if (action.type === 'auth/logout') {
        state = undefined
    }
    return appReducer(state, action)
}

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat(authApi.middleware)
            .concat(userApi.middleware)
            .concat(overviewApi.middleware)
            .concat(companyApi.middleware)
            .concat(servicesApi.middleware)
            .concat(categoriesApi.middleware)
            .concat(locationsApi.middleware)
            .concat(bookingsApi.middleware)
            .concat(eventsApi.middleware)
            .concat(eventTypesApi.middleware)
            .concat(eventSessionsApi.middleware)
            .concat(speakersApi.middleware)
            .concat(customersApi.middleware)
            .concat(staffApi.middleware)
            .concat(adminsApi.middleware)
            .concat(ratingReviewsApi.middleware)
            .concat(salaryApi.middleware)
            .concat(integrationsApi.middleware)
            .concat(impersonateApi.middleware)
            .concat(settingsApi.middleware)
            .concat(modulesApi.middleware)
            .concat(userSettingsApi.middleware)
            .concat(paymentsApi.middleware)
            .concat(payoutsApi.middleware)
            .concat(updateIndexApi.middleware)
            .concat(paymentSettingsApi.middleware)
            .concat(galleryApi.middleware)
            .concat(widgetSettingsApi.middleware)
            .concat(couponsApi.middleware)
            .concat(discountsApi.middleware)
            .concat(giftCardsApi.middleware)
            .concat(giftCardPurchasesApi.middleware)
            .concat(statisticsApi.middleware)
            .concat(certificationApi.middleware)
            .concat(notificationsApi.middleware)
            .concat(storageApi.middleware)
            .concat(productsApi.middleware)
            .concat(resourcesApi.middleware)
            .concat(templatesApi.middleware)
            .concat(salesApi.middleware)
            .concat(messageHelpApi.middleware)
            .concat(creditsApi.middleware)
            .concat(whatsappTemplateApi.middleware)
            .concat(tipsApi.middleware)
            .concat(scheduleApi.middleware)
            .concat(rolesApi.middleware)
            .concat(desksApi.middleware)
})
